import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'employees',
  children: {
    list: {
      path: 'list',
      size: 'full',
      children: {
        wizard: {
          size: 'full',
          path: 'wizard',
        },
        new: {
          size: 'full',
          path: 'new',
        },
        add_employee: {
          size: 'full',
          path: 'add_employee',
        },
        bulkAddTimeOff: {
          size: 'full',
          path: 'bulk-add-time-off',
        },
        expandedAdd: {
          size: 'full',
          path: 'expandedAdd',
          children: {
            step1: {
              path: 'step-1',
              size: 'full',
            },
            step2: {
              path: 'step-2',
              size: 'full',
              children: {
                employeeId: {
                  path: ':employeeId',
                  size: 'full',
                },
              },
            },
            step3: {
              path: 'step-3',
              size: 'full',
              children: {
                employeeId: {
                  path: ':employeeId',
                  size: 'full',
                },
              },
            },
          },
        },
        import: {
          size: 'full',
          path: 'import',
        },
        customTablesImport: {
          size: 'full',
          path: 'custom-tables-import',
        },
        timeoff: {
          size: 'full',
          path: 'timeoff',
        },
        export: {
          size: 'full',
          path: 'export',
        },
        exportTypeSelection: {
          size: 'full',
          path: 'export-type-selection',
        },
        importContracts: {
          size: 'full',
          path: 'import_contracts',
        },
        importContractsMode: {
          size: 'full',
          path: 'import_contracts_mode',
        },
      },
    },
    edit: {
      size: 'full',
      level: 2,
      path: 'edit',
    },
    editContracts: {
      size: 'full',
      level: 2,
      path: 'edit-contracts',
    },
    terminateBulk: {
      size: 'full',
      level: 2,
      path: 'terminate-bulk',
    },
    fijosPauseBulk: {
      size: 'full',
      level: 2,
      path: 'fijos-pause-bulk',
    },
    fijosActivateBulk: {
      size: 'full',
      level: 2,
      path: 'fijos-continue-bulk',
    },
    fdContractBulk: {
      size: 'full',
      level: 2,
      path: 'fd-contract-bulk',
    },
    additionalCompensations: {
      path: 'additional-compensations',
      size: 'full',
      children: {
        create: {
          path: 'create',
          size: 'full',
        },
      },
    },
    bulkFixContracts: {
      size: 'full',
      path: 'bulk-fix-contracts',
    },
    importEmployees: {
      path: 'import-employees/:legal_entity_id/*',
      size: 'full',
      level: 2,
    },
    importContracts: {
      path: 'import-contracts/:legal_entity_id/*',
      size: 'full',
      level: 2,
    },
    import: {
      size: 'full',
      level: 2,
      path: 'import',
      children: {
        datev: {
          size: 'full',
          path: 'datev/:employee_import_id',
        },
      },
    },
    importProcess: {
      size: 'full',
      path: 'import-process',
    },
    contractImport: {
      size: 'full',
      level: 2,
      path: 'contract_import',
    },
    customTablesImport: {
      size: 'full',
      level: 2,
      path: 'custom-tables-import',
    },
    employeeUpdates: {
      size: 'full',
      path: 'activity',
    },
    teams: {
      path: 'teams',
      children: {
        list: {
          path: 'list',
          size: 'full',
          children: {
            add: {
              size: 'full',
              path: 'add',
            },
          },
        },
        id: {
          path: ':id',
          size: 'full',
          level: 2,
          children: {
            addMembers: {
              size: 'full',
              level: 2,
              path: 'add-members',
            },
            edit: {
              size: 'full',
              level: 2,
              path: 'edit',
            },
            delete: {
              size: 'full',
              level: 2,
              path: 'delete',
            },
            addJobCatalogRole: {
              size: 'full',
              level: 2,
              path: 'add-job-catalog-role',
            },
            jobCatalogRoleCreated: {
              size: 'full',
              level: 2,
              path: 'job-catalog-role-created',
            },
          },
        },
        chart: {
          path: 'chart',
          size: 'full',
        },
        importTeams: {
          path: 'import-teams',
          size: 'full',
        },
      },
    },
    organizationChart: {
      path: 'organization-chart',
      size: 'full',
      children: {
        addJobCatalogRole: {
          size: 'full',
          path: 'add-job-catalog-role',
        },
        jobCatalogRoleCreated: {
          size: 'full',
          path: 'job-catalog-role-created',
        },
      },
    },
    peopleChart: {
      path: 'people-chart',
      size: 'full',
    },
    id: {
      path: ':id',
      level: 2,
      children: {
        documents: {
          path: 'documents',
          children: {
            list: {
              level: 2,
              path: 'list',
              children: {
                new: {
                  level: 2,
                  path: 'new',
                },
                documentId: {
                  level: 2,
                  path: ':document_id',
                },
              },
            },
            folderId: {
              level: 3,
              path: ':folderId',
              children: {
                new: {
                  level: 3,
                  path: 'new',
                },
                documentId: {
                  level: 3,
                  path: ':document_id',
                },
              },
            },
          },
        },
        hiring: {
          level: 2,
          path: 'hiring',
        },
        onboarding: {
          path: 'onboarding',
          level: 2,
          children: {
            basic: {
              level: 2,
              path: 'basic',
            },
            registration: {
              level: 2,
              path: 'registration',
            },
            contract: {
              level: 2,
              path: 'contract',
            },
          },
        },
        reviews: {
          level: 2,
          path: 'reviews',
          size: 'full',
          children: {
            reviewId: {
              path: ':review_id',
              children: {
                answers: {
                  level: 3,
                  path: 'answers',
                  size: 'full',
                },
                analytics: {
                  level: 3,
                  path: 'analytics',
                  size: 'full',
                },
              },
            },
            answer: {
              level: 3,
              path: ':review_id/answer',
              children: {
                questionGroupId: {
                  level: 3,
                  path: ':question_group_id',
                },
                splitView: {
                  level: 3,
                  path: 'comparison',
                  size: 'full',
                },
              },
            },
          },
        },
        reviewsReviewIdAnswerQuestionGroupId: {
          level: 3,
          path: 'reviews/:review_id/answer/:question_group_id',
        },
        contractVersions: {
          level: 2,
          path: 'contract_versions',
          children: {
            contractVersionId: {
              level: 2,
              path: ':contractVersionId',
            },
            fix: {
              level: 1,
              path: ':contractVersionId/fix',
            },
            update: {
              level: 1,
              path: 'update',
            },
            promotion: {
              level: 1,
              path: 'promotion',
            },
            approval_request: {
              level: 2,
              path: ':contractVersionId/approval-request',
            },
          },
        },
        timeoffApprovalRequest: {
          level: 1,
          path: 'approval-request/:leaveId',
        },
        personal: {
          level: 2,
          path: 'personal',
        },
        terminate: {
          level: 2,
          path: 'terminate',
        },
        tasks: {
          level: 2,
          path: 'tasks',
          children: {
            new: {
              level: 2,
              path: 'new',
            },
            import: {
              level: 2,
              path: 'import',
            },
            taskId: {
              level: 3,
              path: ':taskId',
            },
          },
        },
        timeOff: {
          level: 2,
          path: 'time-off',
          children: {
            leavesNew: {
              level: 2,
              path: 'leaves/new',
            },
            leavesEditLeaveId: {
              level: 2,
              path: 'leaves/edit/:leave_id',
            },
            leavesRejectLeaveId: {
              level: 2,
              path: 'leaves/reject/:leave_id',
            },
            leaveUpdatesLeaveIdEditMedicalLeave: {
              level: 2,
              path: 'leave_updates/:leave_id/editMedicalLeave',
            },
            leaveUpdatesLeaveIdNew: {
              level: 2,
              path: 'leave_updates/:leave_id/new',
            },
            leaveUpdatesLeaveIdEditLeaveUpdateId: {
              level: 2,
              path: 'leave_updates/:leave_id/edit/:leave_update_id',
            },
            leavesApprovalRequestLeaveId: {
              level: 2,
              path: 'approval-request/:leave_id',
            },
          },
        },
        training: {
          level: 2,
          path: 'training',
          children: {
            nextSession: {
              level: 2,
              path: 'next-session/:sessionId',
              children: {
                certificates: {
                  level: 2,
                  path: 'certificates',
                  children: {
                    upload: {
                      level: 2,
                      path: 'upload',
                    },
                  },
                },
              },
            },
            detail: {
              level: 3,
              path: 'detail',
              children: {
                view: {
                  level: 3,
                  path: 'view/:trainingId',
                  children: {
                    sessionDetail: {
                      level: 3,
                      path: 'session-detail/:sessionId',
                      children: {
                        certificates: {
                          level: 3,
                          path: 'certificates',
                          children: {
                            upload: {
                              level: 3,
                              path: 'upload',
                            },
                          },
                        },
                      },
                    },
                    fileViewer: {
                      level: 3,
                      path: 'file/:trainingFileId',
                    },
                    certificates: {
                      level: 3,
                      path: 'certificates',
                      children: {
                        upload: {
                          level: 3,
                          path: 'upload',
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        planningVersions: {
          level: 2,
          path: 'planning_versions',
          children: {
            planningVersionId: {
              level: 2,
              path: ':planningVersionId',
            },
          },
        },
        competencies: {
          level: 2,
          path: 'competencies',
        },
        customTables: {
          size: 'full',
          level: 2,
          path: 'custom_tables',
          children: {
            schemaIdNew: {
              size: 'full',
              level: 2,
              path: ':schemaId/new',
            },
            schemaIdValuesValueIdEdit: {
              size: 'full',
              level: 2,
              path: ':schemaId/values/:valueId/edit',
            },
            schemaIdValuesValueIdDelete: {
              size: 'full',
              level: 2,
              path: ':schemaId/values/:valueId/delete',
            },
          },
        },
        overview: {
          size: 'full',
          level: 2,
          path: 'overview',
        },
        performance: {
          size: 'full',
          level: 2,
          path: 'performance',
        },
        talent: {
          size: 'full',
          level: 2,
          path: 'talent',
        },
        workDetails: {
          level: 2,
          path: 'work-details',
        },
      },
    },
    jobCatalog: {
      path: 'job-catalog',
      size: 'full',
      children: {
        overview: {
          size: 'full',
          path: 'overview',
          children: {
            node: {
              path: ':id',
              size: 'full',
            },
          },
        },
        importInProgress: {
          path: 'import-in-progress',
          size: 'full',
        },
        importJobCatalogTree: {
          path: 'import-job-catalog-tree/',
          size: 'full',
          level: 2,
        },
        bulkAssignCompetencies: {
          path: 'assign-competencies/',
          size: 'full',
          level: 2,
        },
        root: {
          path: 'root/:rootId',
          size: 'full',
          level: 1,
          children: {
            overview: { path: 'overview', size: 'full', level: 2 },
            workingConditions: { path: 'working-conditions', size: 'full', level: 2 },
            competencies: { path: 'competencies', size: 'full', level: 2 },
            salaries: { path: 'salaries', size: 'full', level: 2 },
            people: { path: 'people', size: 'full', level: 2 },
            itManagement: { path: 'it-management', size: 'full', level: 2 },
            family: {
              path: 'family/:familyId',
              size: 'full',
              level: 2,
              children: {
                overview: { path: 'overview', size: 'full', level: 3 },
                workingConditions: { path: 'working-conditions', size: 'full', level: 3 },
                competencies: { path: 'competencies', size: 'full', level: 3 },
                salaries: { path: 'salaries', size: 'full', level: 3 },
                people: { path: 'people', size: 'full', level: 3 },
                itManagement: { path: 'it-management', size: 'full', level: 3 },
                function: {
                  path: 'function/:functionId',
                  size: 'full',
                  level: 3,
                  children: {
                    overview: { path: 'overview', size: 'full', level: 4 },
                    workingConditions: { path: 'working-conditions', size: 'full', level: 4 },
                    competencies: { path: 'competencies', size: 'full', level: 4 },
                    salaries: { path: 'salaries', size: 'full', level: 4 },
                    people: { path: 'people', size: 'full', level: 4 },
                    itManagement: { path: 'it-management', size: 'full', level: 4 },
                    role: {
                      path: 'role/:roleId',
                      size: 'full',
                      level: 4,
                      children: {
                        overview: { path: 'overview', size: 'full', level: 5 },
                        workingConditions: { path: 'working-conditions', size: 'full', level: 5 },
                        competencies: { path: 'competencies', size: 'full', level: 5 },
                        salaries: { path: 'salaries', size: 'full', level: 5 },
                        people: { path: 'people', size: 'full', level: 5 },
                        itManagement: { path: 'it-management', size: 'full', level: 5 },
                        nodeLevel: {
                          path: 'level/:levelId',
                          size: 'full',
                          level: 6,
                          children: {
                            overview: { path: 'overview', size: 'full', level: 7 },
                            workingConditions: {
                              path: 'working-conditions',
                              size: 'full',
                              level: 7,
                            },
                            competencies: { path: 'competencies', size: 'full', level: 7 },
                            salaries: { path: 'salaries', size: 'full', level: 7 },
                            people: { path: 'people', size: 'full', level: 7 },
                            itManagement: { path: 'it-management', size: 'full', level: 7 },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        list: {
          size: 'full',
          path: 'list',
          children: {
            add: {
              size: 'full',
              path: 'add',
            },
            import: {
              size: 'full',
              path: 'import',
            },
          },
        },
        import_errors: {
          size: 'full',
          path: 'import_errors',
        },
        role: {
          path: 'role/:id',
          level: 2,
          size: 'full',
          children: {
            settings: {
              level: 3,
              path: 'settings',
            },
            salaryRanges: {
              level: 2,
              path: 'salary-ranges',
              size: 'full',
            },
            careerPath: {
              level: 2,
              path: 'career-path',
              size: 'full',
            },
            competencies: {
              level: 2,
              path: 'competencies',
              size: 'full',
              children: {
                assignCompetencies: {
                  size: 'full',
                  path: 'assign-competencies',
                },
                createCompetency: {
                  size: 'full',
                  path: 'create-competency',
                },
                createCompetenciesFromSuggestions: {
                  size: 'full',
                  path: 'create-competencies-from-suggestions',
                },
              },
            },
          },
        },
        bulkEdit: {
          path: 'bulk-edit',
          level: 2,
          size: 'full',
        },
      },
    },
  },
} as const satisfies Location
